import React, { Component } from 'react';
import './Home.css';
import drsanti_image from '../images/santi_nuratch.png';

class Home extends Component {
  render() {
    return (

      <div className="card border-dark mb-3">
        <div className="card-header" style={{ backgroundColor: "#f4f4f4" }}>
          <h2><span className="fa fa-info-circle fa-lg"></span>About</h2>
        </div>
      <div className="card-body" style={{ paddingBottom: "0"}}>
          <div className="row">
            {/* Image */}
            <div className="col-xs-2">
              <img className="santi_img" style={{ marginRight: "20px", }} src={drsanti_image} alt="dr.santi nuratch" />
            </div>

            {/* Information */}
            <div className="col-xs-10" style={{ fontSize: "16px" }}>

              <span style={{ fontSize: "1.5em" }}>Dr.Santi Nuratch</span><br />
              <span style={{ fontSize: "1.5em" }}>ดร.สันติ นุราช</span><br />
              <span style={{ fontSize: "1em" }}><b>Lab: </b>Embedded Computing and Control Laboratory (ECC-Lab)</span><br />
              <span style={{ fontSize: "1em" }}><b>Email: </b>santi.inc.kmutt@gmail.com, santi.nur@kmutt.ac.th</span>

              <hr className="my-2" />
              <div>
                Department of Control System and Instrumentation Engineering (INC)<br />
                King Mongkut’s University of Technology Thonburi (KMUTT)<br />
                126 Pracha-Utit Rd., Bang-Mod, Thung-Kru, Bangkok, Thailand 10140<br />
                Tel: (66) 2470 9317, (66) 2470 9096 Fax: (66) 2470 9100<br />
              </div>
              <hr className="my-2" />
              <span style={{ fontSize: "18px", color: "#888" }}><i>I'm always Learning, Practicing and Teaching. Nothing can stop me!</i></span>
              <hr className="my-2" />
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;

